import { PeriscopeTag } from '.';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { SonarTag } from '@sonar-software/sonar-core';
import { usePeriscopeActions } from '@hooks';
import React, { useCallback } from 'react';

export interface PeriscopeTagListProps {
	tagIds: Array<number>;
	parentIndex: number;
}

export const PeriscopeTagList: React.FC<PeriscopeTagListProps> = ({ tagIds, parentIndex }) => {
	const { openPeriscope } = usePeriscopeActions();

	const handleTagClick = useCallback(
		(tag: SonarTag) => {
			const { name, id } = tag;

			openPeriscope({
				id,
				name,
				openedFromIndex: parentIndex,
				type: SonarObjectType.SonarTag
			});
		},
		[ openPeriscope, parentIndex ]
	);

	return (
		<>
			{ tagIds.map((tagId) =>
				<PeriscopeTag
					key={ tagId }
					onTagClick={ handleTagClick }
					tagId={ tagId } />) }
		</>
	);
};
